/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import Tappable from 'app/components/commons/Tappable';
import * as userActions from 'app/actions/userActions';
import Icon from './Icon';

type Props = {
  hasNightMode: boolean,
  darkMode: boolean,
  className?: string,
  toggleDarkMode: () => void
};

const StyledButton = styled.div(
  ({ theme }) => ({
    marginTop: 6,
    width: '100%',
    fontWeight: theme.fontWeight.normal,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    outline: 'none'
  }),
  ({ theme, selected }) =>
    selected
      ? {
          '& > svg': {
            fill: theme.color.primary
          }
        }
      : {
          '& > svg': {
            fill: 'none',
            stroke: theme.color.primary,
            strokeWidth: 23,
            strokeMiterlimit: 10
          }
        }
);

class NightModeButton extends React.Component<Props> {
  static defaultProps = {
    className: undefined
  };

  render() {
    const { hasNightMode, darkMode, className, toggleDarkMode } = this.props;

    if (!hasNightMode) return null;
    return (
      <Tappable
        component={StyledButton}
        selected={darkMode}
        onTap={toggleDarkMode}
        className={className}
      >
        Night Mode
        <Icon type="icon-moon" />
      </Tappable>
    );
  }
}

function mapStateToProps(state) {
  return {
    darkMode: state.settings.darkMode,
    hasNightMode: state.settings.hasNightMode
  };
}

const actions = {
  toggleDarkMode: userActions.toggleDarkMode
};

export default connect(
  mapStateToProps,
  actions
)(NightModeButton);
